"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AppWrapper;
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    content: {
      backgroundColor: theme.palette.background.default,
      flexGrow: 1,
      height: '100%',
      padding: '0 0 250px 0'
    },
    contentTransition: {
      transition: 'margin 0.2s'
    },
    contentWithDrawer: {
      [theme.breakpoints.up('md')]: {
        marginLeft: function marginLeft(_ref) {
          var collapsed = _ref.collapsed;
          return theme.mixins.mainMenu[collapsed ? 'collapsedDrawerWidth' : 'drawerWidth'];
        }
      }
    },
    root: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
      minHeight: '100%'
    },
    toolbar: theme.mixins.toolbar
  };
});
function AppWrapper(_ref2) {
  var ConnectedAppDrawer = _ref2.ConnectedAppDrawer,
    children = _ref2.children,
    drawer = _ref2.drawer,
    id = _ref2.id,
    collapsed = _ref2.collapsed,
    toggleCollapsed = _ref2.toggleCollapsed;
  var isLargeScreen = (0, _material.useMediaQuery)(function (theme) {
    return theme.breakpoints.up('md');
  });
  var classes = useStyles({
    collapsed
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root,
    id: id
  }, drawer && /*#__PURE__*/_react.default.createElement(ConnectedAppDrawer, {
    collapsed: collapsed,
    id: "".concat(id, "Drawer"),
    toggleCollapsed: isLargeScreen ? toggleCollapsed : undefined
  }), /*#__PURE__*/_react.default.createElement("main", {
    className: (0, _classnames.default)(classes.content, {
      [classes.contentWithDrawer]: drawer,
      [classes.contentTransition]: !!toggleCollapsed
    }),
    id: "".concat(id, "Main")
  }, drawer && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.toolbar
  }), children));
}